import React from 'react';
import types from './types';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Scenario from '../../../classes/scenarioElements/Scenario';

export default function UIPreviousStep(props)
{
	let properties = {
		visible: {
			type: 'toggle',
			typeoverride: 'toggle-icon',
			default: true
		}
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Previous Step'}
				subcomponent={types.PREVIOUS_STEP}
				properties={properties}
				{...props}
			/>
		);
	}
	else if (props.data.visible.value)
	{
		return (
			<div className={"uiButtonStep prev"}
				data-name='ui-preview-previous-step'
			>
				<img alt="next"
					src='./svg/next.svg'
					onClick={(e) =>
					{
						Scenario.goBackInStepHistory(1);
					}}
				/>
			</div>
		);
	}

	return null;
}